import { render, staticRenderFns } from "./FollowRecordCell.vue?vue&type=template&id=173ce794&scoped=true&"
import script from "./FollowRecordCell.vue?vue&type=script&lang=js&"
export * from "./FollowRecordCell.vue?vue&type=script&lang=js&"
import style0 from "./FollowRecordCell.vue?vue&type=style&index=0&id=173ce794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173ce794",
  null
  
)

export default component.exports